import React, { useCallback } from 'react';
import { Col, Row } from 'antd';
import Item from './ArticleItem';
import CategoryTitle from './CategoryTitle';

type Props = {
    category: POYCategory;
    votes: string[];
    handleVote: (categoryId: number, articleSlug: string) => void;
};

const ProductOfTheYearCategory = React.forwardRef<Ref, Props>(
    ({ category, votes, handleVote }, ref): JSX.Element => {
        const onVote = useCallback(
            (articleSlug: string) => {
                handleVote(category.id, articleSlug);
            },
            [category, handleVote]
        );

        const isVoted = useCallback(
            (articleSlug: string): boolean => {
                if (!votes) {
                    return false;
                }
                return votes.includes(articleSlug);
            },
            [votes]
        );

        const articles = category.articles.sort(function (a, b) {
            return new Date(b.dateDisplayed).getTime() - new Date(a.dateDisplayed).getTime();
        });

        return (
            <Col span={24} id={`category__${category.id}`} ref={ref}>
                <CategoryTitle
                    category={category}
                    categoryVotes={Array.isArray(votes) ? votes.length : 0}
                />
                <Row gutter={[32, 48]}>
                    {articles.map((article: Article) => (
                        <Col
                            lg={6}
                            md={8}
                            xs={24}
                            id={`category__${category.id}__${article.seoSlug}`}
                            key={category.id + '-' + article.seoSlug}
                        >
                            <Item
                                article={article}
                                isVoted={isVoted(article.seoSlug)}
                                handleVote={onVote}
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        );
    }
);

ProductOfTheYearCategory.displayName = 'ProductOfTheYearCategory';

export type Ref = HTMLDivElement;

export default ProductOfTheYearCategory;
